import { render, staticRenderFns } from "./WorkerTransferList.vue?vue&type=template&id=73cb361e"
import script from "./WorkerTransferList.vue?vue&type=script&lang=js"
export * from "./WorkerTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports